style= require('./matches.styl')
- var moment = require('moment')
.controls
  .show(class={inactive:this.shown})
    ft-button.button(accent, (click)=this.seasonsSelect())= 'Select seasons'
    if seasons
      .all-seasons= `All seasons (${seasons.length})`
  .back(class={inactive:!this.shown})
    .back-arrow((click)=this.seasonsSelect())
      ft-icon(name=`ui--arrow_left`)
    .label= 'Go back'
  .deselect(class={inactive:!this.shown})
    ft-button(accent, (click)=this.deselect())= "Deselect all"
    .label= `${seasonFilter.length} season(s) selected`
  if !weekly
    .show(class={inactive:this.shown})
      ft-button.button(accent, (click)=this.matchesConfirmation())= 'Sportsbook confirmation'
  if weekly
    .assign-to(class={inactive:this.shown})
      ft-button(accent, (click)= this.showAssignTo())='Assign to:'
      sporty-form-field(
        [(value)]=this.assignee, class={inactive:!this.showAssignButton})
        select
          option(value='')
            | <pick user>
          each user in users
            option(value=user._id selected=user._id === this.user)= user.email
if this.shown
  each sport, index in this.sortedSeasons
    .sport-block
        ft-icon(name=`sports--${sport.type}`)
        .sport= sport.type
        .count= ` (${this.sortedSeasons[index].sortedSeasons.length})`
    .seasons
      each season in this.sortedSportSeasons(sport)
        .season.checking(
          class=this.seasonClass(season),
          data-season=season._id,
          (click)=this.toggle(season._id)
        ) 
          .section
            img.season-icon(src=season.iconUrl)
            .icon-name
              section
                .name= [season.league.name, season.season].join(' ')
              section
                .live
                  - var live = seasonCount[season._id]
                  if live
                    .status-text #{live} live games
          .toggle(class= {'checked': this.seasonClass(season) === 'selected'})
            ft-icon(name="ui--tick")

.matchFilters
  .buttons
    label.show-only Show only
    each tab in tabs
      .filter-item.statuses(
        class=tab,
        class= this.tabClass(tab),
        (click)=this.setTab(tab)
      )
        = tab[0].toUpperCase() + tab.slice(1)
        - var count = tabCount[tab]
        if count
          .counter= ` (${count})`
  if weekly
    ft-button.button-filter(accent,(click)=(this.render(this.dropdownShow = !this.dropdownShow)) )
      ft-icon(name=`ui--filtering`)
      = 'Filters'
    .dropdowns(class={'dropdowns__show':this.dropdownShow})
      .filter-dropdown
        label Claimed by
        sporty-form-field.filters([(value)]=this.user)
          select
            each opt in userOptions
              option(value=opt.value selected=opt.value === this.user)= opt.label
            each user in users
              option(value=user._id selected=user._id === this.user)= user.email
      .filter-dropdown
        label Assigned to
        sporty-form-field([(value)]=this.assigneduser)
          select
            option(value='')
              | <pick user>
            each user in users
              option(value=user._id selected=user._id === this.user)= user.email
      .filter-dropdown
        label Sport
        sporty-form-field.sport-selector([(value)]=this.sportfilter)
          select
            option(value='')
              | <pick sport>
            each sport in this.sortedSeasons
              option(value=sport.type selected=sport.type === this.sport)= sport.type
      .filter-dropdown
        label From date
        sporty-form-field([(value)]=this.after)
          input(type='date')
      .filter-dropdown
        label To date
        sporty-form-field([(value)]=this.before)
          input(type='date')
.matches(class={weekly: weekly, matchPage: !weekly})
  if weekly
    - var today = moment().format('dddd')
    each day in moment.weekdays()
      .match.week-day(class={[day]: true, today: day === today})= day
  each match, index in realMatches
    .match.tile(class=this.matchClass(match, weekly), class={matchPage: !weekly},(click)=this.claim(match, e))
      .header(class=this.matchClass(match, weekly))
        ft-clipboard.id
          span= match._id
          span.match-icon
            ft-icon(name=`ui--clipboard`)
      sporty-status(match=match)
      .assign-place
        if !this.showAssignButton
          .assigned
            label Assigned:
            if match.delegate
              - var cutEmail = match.delegate.email?.split('@')[0]
              .owner= cutEmail
            else
              .no-owner None
          .claim-box
            .toggle(class= {'checked': matchClass(match) === 'owned'})
              ft-icon(name="ui--tick")

            label.claim Claim
            if match.user
              - var cutEmailUser = match?.user.email?.split('@')[0]
              .user= cutEmailUser
        else
          if assignee && assignee._id !== '-1' && this.showAssignButton && (match.delegate?._id || -1) != assignee._id
            if weekly
              .assign-line
                .assign(
                  (click)=this.tryClaiming(match, e, assignee, 'assign'))
                    =`Assign: ${assignee.email?.split('@')[0]}`
          if assignee && assignee._id !== '-1' && this.showAssignButton && match.delegate 
            if weekly
              .assign-line
                .unassign(
                  (click)=this.tryClaiming(match, e, assignee, 'unassign'))
                    =`unasign: ${match.delegate.email?.split('@')[0]}`
    
        
